import { useEffect, useState } from 'react';
import SlotItem from './SlotItem.js';


export default function SectionSkin({ skins, skin, setSkin }) {
    return (
        <div data-slot='skin' className='skin'>
            <h2>Skin</h2>
            <ul>
                { skins.map((item) => {
                    return <SlotItem
                        key={item.index}
                        skin={item.index}
                        active={skin === item.index}
                        onClick={() => { setSkin(item.index); }}
                        image={`/img/thumbnails/skin_${item.index}.webp`} />
                }) }
            </ul>
        </div>
    );
}
